<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">Innovations Distribution</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>

                                        Building a robust pool of users, community of innovators, researchers and many
                                        more, with a target of several Millions in the coming years, we chose to take
                                        the best innovations from accross the continent and work to distribute together
                                        with our partners, to make acceptance, adoptions and penetration easier.
                                        <br>
                                        With effective distribution models developed we’re working on;
                                    </p>
                                    <ul class="list">
                                        <li>
                                            Tribinnov Media:
                                            <br>
                                            This is a robust set of activities to communicate about the best innovations
                                            and brands accross the continent via documentaries and writings
                                        </li>
                                        <li>
                                            Africa Innovation Show
                                        </li>
                                        <li>
                                            Wrinnov:
                                            <br>
                                            A micro blogging SAAS for Creators, innovators, researchers and more.
                                        </li>
                                        <li>
                                            African Life & Business Tourism - AFLIBUT for Tribinnov investors in
                                            Diaspora to view our businesses on the continent
                                        </li>
                                        <li>
                                            Tribinnov Exchange:
                                            <br>
                                            A Pan African Trade network to distribute innovations accross Africa and
                                            into the other parts of the globe
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InnovationDistribution',
        metaInfo: {
            title: "Tribinnov Africa - Innovations Distribution",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
                //you can also add open graph tags here
            ]
        }
    }
</script>